import { type DocumentNode, gql } from '@apollo/client';

const refreshToken: DocumentNode = gql`
  mutation refreshToken($token: String!) {
    refreshToken(token: $token) {
      token
      payload
      refreshExpiresIn
    }
  }
`;

export default refreshToken;
